import { Button, Divider, Layout, Select, Space, Table } from 'antd';
import { CreateCustomsModal } from './CreateCustomsModal';
import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import querystring from 'query-string';
import { render } from '@testing-library/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { title } from 'process';
import dayjs from 'dayjs';
import CustomerSelect from '../../lib/CustomerSelect';
import queryString from 'query-string';
const columns = [
  {
    title: 'Тээврийн баримтын дугаар',
    key: 'airBill',
    dataIndex: 'airBill',
    render: (text: any, record: any) => {
      return (
        <div>
          <Link to={`/foreign/customs/${text}`}>{text}</Link>
        </div>
      );
    },
  },
  {
    title: 'Үүссэн',
    key: 'createdAt',
    dataIndex: 'createdAt',
    render: (val: any) => {
      console.log(val);
      return dayjs(val).format('YYYY-MM-DD HH:mm');
    },
  },
  {
    title: 'Харилцагч',
    dataIndex: 'customer',
    key: 'airBill',
    render: (text: any, record: any) => {
      return (
        <div>
          <span>{text?.name}</span>
        </div>
      );
    },
  },
  {
    title: 'Гаалийн төлөв',
    dataIndex: 'processStatus',
    render: (text: any, record: any) => {
      return (
        <div>
          <span>{text?.text}</span>
        </div>
      );
    },
    key: 'airBill',
  },
  {
    title: 'Илгээмийн тоо',
    dataIndex: 'shipmentCount',
    key: 'shipmentCount',
  },
  {
    title: 'Дутуу илгээмж',
    dataIndex: 'pendingCount',
    key: 'pendingCount',
  },
  {
    title: 'Төлөв',
    dataIndex: 'shipmentStatus',
    key: 'shipmentStatus',
    render: (text: any, record: any) => {
      return (
        <div>
          <span>{text?.name}</span>
        </div>
      );
    },
  },
];
interface CustomsFilter {
  airBill?: string;
  page: number;
  customerNo?: number;
  status?: string;
  customsStatus?: string;
}

const ForeignOrderCustoms = () => {
  const [showCreate, changeShowCreate] = useState(false);
  const [data, changeData] = useState({ data: [], page: 1, total: 0, size: 20 });
  const [filter, setFilter] = useState<CustomsFilter>({ page: 1 });
  const [searchState, changeSearchState] = useState<any>({});
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      fetchData(location.search);
    } else {
      setTimeout(() => {
        navigate(`/foreign/customs?page=1`);
      }, 100);
    }
  }, [location.search]);
  useEffect(() => {
    if (searchState) {
      navigate(`/foreign/customs?${queryString.stringify(searchState)}`);
    }
  }, [searchState]);
  const changeSearch = useCallback(
    (val: any) => {
      const res = { ...queryString.parse(location.search), ...val };
      navigate(`?${queryString.stringify(res)}`);
    },
    [navigate, location]
  );

  const fetchData = async (filter: any) => {
    try {
      console.log('sdfsdf', filter);
      var str = querystring.stringify(filter);
      const response = await API.get({ apiVersion: 'api' })(`/customs/list?${filter}`);
      changeData(response.result);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <h3>Гаалийн мэдүүлэг</h3>
      <Divider />
      <div className="search-area">
        <Space wrap style={{ marginBottom: 15 }}>
          <CustomerSelect
            showSearch
            defaultQuery={{ type: 'CN' }}
            allowClear
            value={filter.customerNo ? filter.customerNo.toString() : undefined}
            onChange={(value) => {
              changeSearch({ ...filter, customerNo: value });
            }}
          />
        </Space>
        <Divider />
        <Space>
          <Button onClick={() => changeShowCreate(true)} type="primary">
            Гаалийн мэдүүлэг үүсгэх
          </Button>
        </Space>
      </div>
      <Table columns={columns} dataSource={data.data} />
      <CreateCustomsModal
        visible={showCreate}
        onCancel={() => changeShowCreate(false)}
        onSuccess={() => changeShowCreate(false)}
      />
    </Layout.Content>
  );
};
export default ForeignOrderCustoms;
